import { create } from 'zustand';

interface CaseQtyState {
  byCase: Record<string, number>;
  setQty: (caseId: string, qty: number) => void;
}

export const useCaseQtyStore = create<CaseQtyState>((set) => ({
  byCase: {},
  setQty: (caseId, qty) => set((s) => ({ byCase: { ...s.byCase, [caseId]: qty } })),
}));

export const getStoredCaseQty = (caseId: string): number =>
  useCaseQtyStore.getState().byCase[caseId] ?? 1;
